module.exports = __webpack_public_path__ + "img/Mean Girls poster.89b8f135.png";